<template>
  <!--TW船运唛头 不授权的 -->
  <div>
    <div class="main" v-for="(datas, index) in printData" :key="index" :datas="index">
      <div class="content">
        <div class="top">
          <div class="title">TW NO：</div>
          <div class="top-title">{{ datas.express_no }}</div>
        </div>
        <!-- 中间 -->
        <div class="middle">
          <!-- FBA授权 -->
          <p style="font-size: 35px;text-align: center;" v-if="datas.porder.is_fba">
            {{ datas.porder.importer.company }}
          </p>
          <div class="order">{{ datas.porder_sn }}</div>
          <p style="font-size: 40px;" v-if="datas.porder.split_from" class="order">原单号:{{ datas.porder.split_from }}</p>
          <p style="font-size: 40px;" v-if="datas.porder.from_porder_sn" class="order">原单号:{{
      datas.porder.from_porder_sn }}</p>
          <div class="username">{{ datas.porder.user.realname }} - {{ datas.number }}</div>
          <div class="tiaoxingma">
            <canvas :id="'express_no' + index" style="height:200px;margin: 40px 0;" />
          </div>
          <div class="MADE">MADE IN CHINA</div>
          <div class="order_box" v-if="datas.order_box">{{ datas.order_box.order_sn }}-{{
      datas.order_box.box_no }}
          </div>
          <div class="name">
            <span>担当：{{ datas.porder.y_admin.realname }}</span> <span>配货：{{ datas.porder.p_admin.realname }}</span>
          </div>
        </div>
        <!-- 尾部 -->
        <div class="footer">
          <div class="size">
            Weight: <span>{{ datas.weight }}</span>
          </div>
          <div class="size">
            Size: <span>{{ datas.length }}x{{ datas.width }}x{{ datas.height }}</span>
          </div>
          <div class="no">
            CTNO. {{ datas.number_by_express_no }}/{{ datas.count_by_express_no }}
          </div>
          <div class="time">
            {{ getDate() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDate } from '@/utlis/date'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(
      {
        printData: (state) => state.porderDetail.printData, //要打印的数据
      }
    )
  },

  data() {
    return {
      getDate
    };
  },
  mounted() {
    this.printData.forEach((item, index) => {
      this.getJsBarcode("#express_no" + index, item.express_no);
    })
  },
  methods: {

    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 240,
        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #fff;
  padding: 60px;
  box-sizing: border-box;
  color: #000000 !important;

  div {
    box-sizing: border-box;
  }

  .content {
    width: 1061px;
    height: 1652px;
    border: 8px solid #000000;

    .top {
      height: 460px;
      box-sizing: border-box;
      border-bottom: 8px solid #000000;

      .title {
        width: 400px;
        height: 120px;
        background: #000000;
        text-align: center;
        line-height: 120px;
        font-size: 72px;
        font-weight: 600;
        color: #ffffff;
        margin: 0;
      }

      .top-title {
        width: 100%;
        text-align: center;
        font-size: 120px;
        line-height: 180px;
        font-weight: 600;
        color: #000000;
        margin: 45px 0;
      }
    }

    .middle {
      padding: 80px 60px 43px;
      border-bottom: 8px solid #000000;

      .order {
        font-size: 72px;
        text-align: center;
        font-weight: 400;
        color: #000000;
        line-height: 80px;
      }

      .username {
        font-size: 48px;
        font-weight: 400;
        color: #000000;
        line-height: 83px;
        text-align: center;
      }

      .tiaoxingma {

        height: 240px !important;
        overflow: hidden;
        margin: 40px 0;

        img {
          height: 240px !important;
        }
      }

      .MADE {
        width: 560px;
        height: 96px;
        background: #000000;
        font-size: 64px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 96px;
        text-align: center;
        margin: 20px auto;
      }

      .name {
        font-size: 48px;
        font-weight: 400;
        color: #000000;

        span {
          &:nth-last-child(1) {
            float: right;
          }
        }
      }

      .order_box {
        font-size: 65px;
        margin-bottom: 20px;
      }
    }

    .footer {
      width: 100%;
      position: relative;

      .no {
        position: absolute;
        top: -80px;
        right: 60px;
        text-align: center;
        font-size: 56px;
        margin: 80px 0 60px;
        line-height: 80px;
      }

      .size {
        margin: 60px;
        font-size: 56px;

        span {
          font-weight: bold;
        }
      }

      .time {
        position: absolute;
        right: 60px;
        top: 120px;
        font-size: 40px;
      }


    }
  }
}
</style>
